export const rackRailsProducts = [
  {
    id: "384-14303-3103a0",
    name: {
      de: '17,2" Teleskop-Schienenkit Chenbro 384-14303-3103A0',
      en: '17.2" Telescopic Sliding Rail Set Chenbro 384-14303-3103A0',
      es: 'Kit de rieles telescópicos de 17,2" Chenbro 384-14303-3103A0'
    },
    description: {
      de: "Hochwertiger, robuster und kurzer 17,2-Zoll-Teleskopschienensatz von Chenbro für die Installation von 19-Zoll-Gehäusen in Serverschränken. Geeignet für Rack-Abstände von ca. 50 bis 70 cm. Empfohlen für Chenbro RM14300, RM14302, RM14604, RM14608 und RM14610.",
      en: "High-quality, robust and short 17.2-inch telescopic sliding rail set from Chenbro for installing 19-inch enclosures in server racks. Suitable for rack spacing of approximately 50 to 70 cm. Recommended for Chenbro RM14300, RM14302, RM14604, RM14608 and RM14610.",
      es: "Juego de rieles telescópicos cortos y robustos de 17,2 pulgadas de Chenbro para instalar chasis de 19 pulgadas en racks de servidor. Apto para una distancia entre postes de aproximadamente 50 a 70 cm. Recomendado para Chenbro RM14300, RM14302, RM14604, RM14608 y RM14610."
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '17.2" | Telescopic Sliding Rail Set | 50-70 cm Rack Depth | RM14300/RM14302/RM14604/RM14608/RM14610',
    imageUrl: "/images/products/rack-rails/384-14303-3103a0.jpg",
    images: ["/images/products/rack-rails/384-14303-3103a0.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h323610-034",
    name: {
      de: 'Chenbro 84H323610-034 Rackmount-Schienen 26" Easy Mount',
      en: 'Chenbro 84H323610-034 Rackmount Rails 26" Easy Mount',
      es: 'Rieles Rackmount Chenbro 84H323610-034 de 26" Easy Mount'
    },
    description: {
      de: '26-Zoll-Rackmount-Schienen von Chenbro mit Easy-Mount-Design. Auszugsweg 27,5 Zoll und Traglast bis 45,0 kg. Kompatibel mit 2HE-, 3HE- und 4HE-Chassis, darunter RM24200, RM21706, RM23608, RM23612, RM23616, RM23624, RM31408, RM31616, RM41300 und RM42300.',
      en: '26-inch rackmount rails from Chenbro with easy-mount design. Traveling distance 27.5 inches and loading weight up to 45.0 kg. Compatible with 2U, 3U and 4U chassis including RM24200, RM21706, RM23608, RM23612, RM23616, RM23624, RM31408, RM31616, RM41300 and RM42300.',
      es: 'Rieles rackmount Chenbro de 26 pulgadas con diseño easy mount. Recorrido de 27,5 pulgadas y capacidad de carga de hasta 45,0 kg. Compatibles con chasis 2U, 3U y 4U, incluidos RM24200, RM21706, RM23608, RM23612, RM23616, RM23624, RM31408, RM31616, RM41300 y RM42300.'
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '26" | Easy Mount | Travel 27.5" | Load 45.0 kg | 2U/3U/4U Compatible',
    imageUrl: "/images/products/rack-rails/84h323610-034.jpg",
    images: ["/images/products/rack-rails/84h323610-034.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h314610-003",
    name: {
      de: 'Chenbro 84H314610-003 Rackmount-Schienen 23,6" für RM133/RM143/RM146',
      en: 'Chenbro 84H314610-003 Rackmount Rails 23.6" for RM133/RM143/RM146',
      es: 'Rieles Rackmount Chenbro 84H314610-003 de 23,6" para RM133/RM143/RM146'
    },
    description: {
      de: '23,6-Zoll-Rackmount-Schienen von Chenbro für Chassis der Serien RM133, RM143 und RM146. Entwickelt für eine stabile und zuverlässige Montage im Rack.',
      en: '23.6-inch rackmount rails from Chenbro for RM133, RM143 and RM146 series chassis. Designed for stable and reliable rack installation.',
      es: 'Rieles rackmount Chenbro de 23,6 pulgadas para chasis de las series RM133, RM143 y RM146. Diseñados para una instalación estable y fiable en rack.'
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '23.6" | Rackmount Rails | RM133/RM143/RM146 Series Compatible',
    imageUrl: "/images/products/rack-rails/84h314610-003.jpg",
    images: ["/images/products/rack-rails/84h314610-003.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h210710-024",
    name: {
      de: 'Chenbro 84H210710-024 Rackmount-Schienen 26" für SR209+/SR105+/SR107+',
      en: 'Chenbro 84H210710-024 Rackmount Rails 26" for SR209+/SR105+/SR107+',
      es: 'Rieles Rackmount Chenbro 84H210710-024 de 26" para SR209+/SR105+/SR107+'
    },
    description: {
      de: '26-Zoll-Rackmount-Schienen von Chenbro mit Kugellager-Mechanismus für eine stabile und leichtgängige Rack-Montage. Kompatibel mit den Serien SR105 Plus, SR209 Plus, SR107 Plus, SR209, SR105, SR112 und SR107.',
      en: '26-inch rackmount rails from Chenbro with ball bearing mechanism for stable and smooth rack installation. Compatible with SR105 Plus, SR209 Plus, SR107 Plus, SR209, SR105, SR112 and SR107 series chassis.',
      es: 'Rieles rackmount Chenbro de 26 pulgadas con mecanismo de rodamientos de bolas para una instalación en rack estable y suave. Compatibles con las series SR105 Plus, SR209 Plus, SR107 Plus, SR209, SR105, SR112 y SR107.'
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '26" | Rackmount Rails | Ball Bearing | SR105/SR107/SR112/SR209 Series Compatible',
    imageUrl: "/images/products/rack-rails/84h210710-024.jpg",
    images: ["/images/products/rack-rails/84h210710-024.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h341300-002",
    name: {
      de: 'Chenbro 84H341300-002 Rackmount-Schienen 26" für RM236/RM241/RM242',
      en: 'Chenbro 84H341300-002 Rackmount Rails 26" for RM236/RM241/RM242',
      es: 'Rieles Rackmount Chenbro 84H341300-002 de 26" para RM236/RM241/RM242'
    },
    description: {
      de: 'Rackmount-Schienen von Chenbro mit 27,7 Zoll Auszugsweg und 27,0 kg Traglast. Kompatibel mit RM42300, RM21600, RM23612, RM23608, RM24200, RM24100, RM21706, RM31300, RM31408, RM31616, RM41300, RM23616, RM23624 und RM42200.',
      en: 'Rackmount rails from Chenbro with 27.7-inch traveling distance and 27.0 kg loading weight. Compatible with RM42300, RM21600, RM23612, RM23608, RM24200, RM24100, RM21706, RM31300, RM31408, RM31616, RM41300, RM23616, RM23624 and RM42200.',
      es: 'Rieles rackmount Chenbro con recorrido de 27,7 pulgadas y capacidad de carga de 27,0 kg. Compatibles con RM42300, RM21600, RM23612, RM23608, RM24200, RM24100, RM21706, RM31300, RM31408, RM31616, RM41300, RM23616, RM23624 y RM42200.'
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '26" | Travel 27.7" | Load 27.0 kg | RM236/RM241/RM242/RM413/RM423 Compatible',
    imageUrl: "/images/products/rack-rails/84h341300-002.jpg",
    images: ["/images/products/rack-rails/84h341300-002.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h342310-001",
    name: {
      de: 'Chenbro 84H342310-001 Rackmount-Schienen 20" für RM423',
      en: 'Chenbro 84H342310-001 Rackmount Rails 20" for RM423',
      es: 'Rieles Rackmount Chenbro 84H342310-001 de 20" para RM423'
    },
    description: {
      de: '20-Zoll-Rackmount-Schienen von Chenbro für Chassis der RM423-Serie. Geeignet für 4HE-Installationen und für eine stabile Rack-Montage ausgelegt.',
      en: '20-inch rackmount rails from Chenbro for RM423 series chassis. Suitable for 4U installations and designed for stable rack mounting.',
      es: 'Rieles rackmount Chenbro de 20 pulgadas para chasis de la serie RM423. Aptos para instalaciones 4U y diseñados para un montaje estable en rack.'
    },
    category: "Rack Rails",
    application: "accessory",
    specs: '20" | Rackmount Rails | 4U | RM423 Series Compatible',
    imageUrl: "/images/products/rack-rails/84h342310-001.jpg",
    images: ["/images/products/rack-rails/84h342310-001.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h210510-004",
    name: {
      de: 'Chenbro 84H210510-004 Rackmount-Griffe für SR105+/SR209+',
      en: 'Chenbro 84H210510-004 Rackmount Handle for SR105+/SR209+',
      es: 'Manijas Rackmount Chenbro 84H210510-004 para SR105+/SR209+'
    },
    description: {
      de: 'Schwarzer Rackmount-Griffsatz von Chenbro, 2 Stück pro Set. Kompatibel mit den Chassis-Serien SR209 Plus, SR105 Plus, SR209 und SR105.',
      en: 'Black rackmount handle set from Chenbro, 2 pieces per set. Compatible with SR209 Plus, SR105 Plus, SR209 and SR105 series chassis.',
      es: 'Juego de manijas rackmount negras de Chenbro, 2 piezas por set. Compatible con las series de chasis SR209 Plus, SR105 Plus, SR209 y SR105.'
    },
    category: "Accessories",
    application: "accessory",
    specs: 'Rackmount Handle | Black | 2 pcs/set | SR105/SR209 Series Compatible',
    imageUrl: "/images/products/rack-rails/84h210510-004.jpg",
    images: ["/images/products/rack-rails/84h210510-004.jpg"],
    productUrl: "",
    price: null
  },
  {
    id: "84h210710-035",
    name: {
      de: 'Chenbro 84H210710-035 Rackmount-Ohren für SR107/SR107+',
      en: 'Chenbro 84H210710-035 Rackmount Ears for SR107/SR107+',
      es: 'Orejas Rackmount Chenbro 84H210710-035 para SR107/SR107+'
    },
    description: {
      de: 'Schwarzes Rackmount-Ears-Set von Chenbro, 2 Stück pro Set. Kompatibel mit den Chassis-Serien SR107 Plus, SR112 und SR107.',
      en: 'Black rackmount ears set from Chenbro, 2 pieces per set. Compatible with SR107 Plus, SR112 and SR107 series chassis.',
      es: 'Juego de orejas rackmount negras de Chenbro, 2 piezas por set. Compatible con las series de chasis SR107 Plus, SR112 y SR107.'
    },
    category: "Accessories",
    application: "accessory",
    specs: 'Rackmount Ears | Black | 2 pcs/set | SR107/SR112 Series Compatible',
    imageUrl: "/images/products/rack-rails/84h210710-035.jpg",
    images: ["/images/products/rack-rails/84h210710-035.jpg"],
    productUrl: "",
    price: null
  },
]; 
